
export default {
    name: 'blocked-ui',
    components: {},
    props: [],
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {

    }
}


